import React from "react";
import { connect } from "react-redux";
import "./DeviceButtonGroup.css";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import TabletMacIcon from "@material-ui/icons/TabletMac";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import { templateConstants } from "../../../../../constants/cms/template/template.constants";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";

const cDevices = [
  {
    name: "Desktop",
    id: templateConstants.DESKTOP
  },
  {
    name: "Tablet",
    id: templateConstants.TABLET
  },
  {
    name: "SmartPhone",
    id: templateConstants.SMARTPHONE
  }
];

const DeviceButtonGroup = ({ device, dispatch }) => {
  const deviceIcon = (className, d, style = {}) => {
    let badgeClass =
      d === device ? "device-badge current-device" : "device-badge";
    switch (d) {
      case "desktop":
        return (
          <span
            className={badgeClass}
            onClick={() => dispatch(templateActions.togglePreviewMode(d))}
          >
            <DesktopWindowsIcon className={className} />
          </span>
        );
      case "tablet":
        return (
          <span
            className={badgeClass}
            onClick={() => dispatch(templateActions.togglePreviewMode(d))}
          >
            <TabletMacIcon className={className} />
          </span>
        );
      case "smartphone":
        return (
          <span
            className={badgeClass}
            onClick={() => dispatch(templateActions.togglePreviewMode(d))}
          >
            <SmartphoneIcon className={className} />
          </span>
        );
      default:
        return "";
    }
  };
  const getDeviceOptions = () => {
    let devices = [];
    cDevices.map((d, index) => {
      devices.push(deviceIcon("device-icon-sm", d.id));
    });
    return devices;
  };
  return (
    <div style={{ display: "inline-flex", marginLeft: "25px" }}>
      {getDeviceOptions().map((d, i) => {
        return <React.Fragment key={i}>{d}</React.Fragment>;
      })}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    device: state.template.previewDevice
  };
}
export default connect(mapStateToProps)(DeviceButtonGroup);
